import {
  HOME_PAGE_URL,
  BOOKING_PAGE_URL,
  BOOKING_ADMIN_PAGE_URL,
  CONTACT_PAGE_URL,
  ABOUT_PAGE_URL,
  CONTACT_ADMIN_PAGE_URL,
  COMMERCIALS_PAGE_URL,
  WELLNESS_PAGE_URL,
} from '../Routes';

export const getNavLinkItemsArray = (user) => [
  { path: HOME_PAGE_URL, label: 'Home' },
  { path: ABOUT_PAGE_URL, label: 'About' },
  { path: COMMERCIALS_PAGE_URL, label: 'Commercials' },
  { path: WELLNESS_PAGE_URL, label: 'Wellness' },
  { path: BOOKING_PAGE_URL, label: 'Booking' },
  { path: CONTACT_PAGE_URL, label: 'Contact' },
  ...(user?.email
    ? user.role === 'ADMIN' || user.role === 'DEVELOPER'
      ? [
          {
            label: 'Admin',
            subpages: [
              { path: CONTACT_ADMIN_PAGE_URL, label: 'Contact Admin' },
              { path: BOOKING_ADMIN_PAGE_URL, label: 'Booking Admin' },
            ],
          },
        ]
      : []
    : []),
];
